import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolIncidentSetup } from "../shared/data.service";
import { SchoolIncidentInsertRequest } from "../shared/SchoolIncidentInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-add-school-incident",
	templateUrl: "./add-school-incident.component.html",
	styleUrls: ["./add-school-incident.component.css"],
})
export class AddSchoolIncidentComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolIncidentSetupService: DataService_SchoolIncidentSetup
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.user = this.dialogConfig.data.user;

		this.LoadIncidentTypes();
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////

	//Data from Parent
	SchoolID: any;
	user: any;

	//Form
	SchoolIncidentTypeID: any;
	lstSchoolIncidentType: any = [];
	IncidentDate: Date = new Date();
	IncidentTime: Date = new Date();
	Comments: string = "";

	errorMessage: any = "";

	//////////////////////////////////////

	//////////////////////////////////////
	// Load Data
	//////////////////////////////////////
	LoadIncidentTypes() {
		var result = this.SchoolIncidentSetupService.SchoolIncidentTypeSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSchoolIncidentType = response;

				this.SchoolIncidentTypeID = this.lstSchoolIncidentType[0].SchoolIncidentTypeID;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		var fDate = moment(this.IncidentDate).format("MM/DD/YYYY") + " " + moment(this.IncidentTime).format("HH:mm:00");
		if (fDate == "" || fDate == undefined || String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Date or Time";
			return;
		}

		if (String(this.Comments).length > 512) {
			this.errorMessage = "Comments cannot be longer than 512 characters";
			return;
		}

		let parms: SchoolIncidentInsertRequest = {
			SchoolID: this.SchoolID,
			SchoolIncidentTypeID: this.SchoolIncidentTypeID,
			IncidentDT: fDate,
			Comment: this.Comments,
			Administrator_PersonID: this.user.personID,
		};

		//Call SP
		var result = this.SchoolIncidentSetupService.SchoolIncidentInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Incident was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the School Incident",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////
}
